import { CharityIcon } from './CharityIcon';

/**
 * author: Google
 * id B5589411-20E7-4552-BEC5-A394068B23A7
 * name charity
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/charity.svg
 * tags
 */
export const SuperChatForGoodIcon = CharityIcon;
export default SuperChatForGoodIcon